import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ReaderCreditsModal from "./ReaderCreditsModal";

/**
 * ReaderTopMenuBar - Secondary navigation bar for authenticated Reader Mode
 * 
 * Desktop: Horizontal menu with navigation links
 * Mobile: Wrapping menu (no horizontal scroll)
 * 
 * Note: Credits display moved to ReaderNav for cleaner UI
 */
const ReaderTopMenuBar = () => {
  const location = useLocation();
  const [creditsModalOpen, setCreditsModalOpen] = useState(false);

  const readerMenuItems = [
    { label: 'Reader Home', path: '/home' },
    { label: 'My Library', path: '/reader/my-library' },
    { label: 'Pricing', path: '/pricing' },
    { label: 'FAQ', path: '/faq' },
    { label: 'Contact', path: '/contact' },
    { label: 'About', path: '/about' }
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      <nav className="bg-slate-900/95 backdrop-blur-md border-b border-slate-800">
        <div className="mx-auto max-w-6xl">
          {/* Desktop & Mobile: Menu bar */}
          <div className="flex flex-wrap justify-center items-center px-3 py-2 gap-1.5 sm:gap-2">
            {/* Navigation Links */}
            <div className="flex flex-wrap justify-center items-center gap-1.5 sm:gap-2">
              {readerMenuItems
                .filter(item => !isActive(item.path)) // Hide current page link
                .map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className="px-3 py-1.5 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-medium text-slate-300 hover:text-white hover:bg-slate-800 transition-all whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                ))}
            </div>
          </div>
        </div>
      </nav>

      {/* Transaction Modal - kept for potential future use */}
      <ReaderCreditsModal
        isOpen={creditsModalOpen}
        onClose={() => setCreditsModalOpen(false)}
      />
    </>
  );
};

export default ReaderTopMenuBar;
